import { useEffect, useState } from 'react';

/**
 * Reactive media query match, unlike the one-off `window.matchMedia(...).matches`
 * reads scattered across the app (AppShell, GridPageLayout) that never update
 * after mount. Extracted from the private `useIsMobile` in
 * src/shared/components/Grid/ToolbarOverflow.tsx so any component can react
 * to a breakpoint or `prefers-*` query changing live.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => (
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false
  ));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(query);
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
